import React, { useCallback, useEffect, useState } from 'react';
import { copyToClipboard } from '../../utils';
import { formatBotMessage } from './utils'
import { useScrollContext } from '../../common/contexts/scroll';
import { SCROLL_REFERENCE_KEYS } from '../../constants';
import CustomAnchor from '../custom-anchor';
import { useToaster } from '../../common/contexts/toast';

const ChatItem = ({ chatData, onUpdateChat, onRetry }) => {

    const [isMessageCopied, setIsMessageCopied] = useState(false)

    const { scrollToElement } = useScrollContext()
    const { showToaster } = useToaster()

    const handleCopy = useCallback(() => {
        copyToClipboard(`${chatData.question}\n\n${chatData.response}`, () => {
            showToaster && showToaster("copy-message", "Copied to clipboard", true)
            setIsMessageCopied(true)
            setTimeout(()=>{
                setIsMessageCopied(false)
            }, 500)
        })
    }, [chatData, showToaster]);

    const handleLike = useCallback(() => {
        onUpdateChat(chatData.id, { isLiked: !chatData.isLiked, isDisliked: false });
    }, [chatData.id, chatData.isLiked, onUpdateChat]);

    const handleDislike = useCallback(() => {
        onUpdateChat(chatData.id, { isDisliked: !chatData.isDisliked, isLiked: false });
    }, [chatData.id, chatData.isDisliked, onUpdateChat]);

    useEffect(() => {
        if(chatData.status === "loading"){
            // when loading, scroll to Thinking text
            scrollToElement(SCROLL_REFERENCE_KEYS.chatList, `[data-chat-id="${chatData.id}"] .loading-response`)
        }else if((chatData.status === "completed") || (chatData.status === "error")){
            // when completed or error, scroll to asked question
            scrollToElement(SCROLL_REFERENCE_KEYS.chatList, `[data-chat-id="${chatData.id}"] .chat-question`, 125)
        }
    }, [chatData.status, chatData.id, scrollToElement])

    return (
        <div className={`chat-item status-${chatData.status}`} data-chat-id={chatData.id}>
            <div className='chat-question'>
                <p className='chat-question-text' dir='auto'>{chatData.question}</p>
                {(chatData.status === "error") && <CustomAnchor className="retry-text" onClick={onRetry}>Try Again</CustomAnchor>}
            </div>
            <div className='chat-response'>
                {!!chatData.response && <div dir='auto' dangerouslySetInnerHTML={{ __html: formatBotMessage(chatData.response) }}/>}
                {(chatData.status === "loading") && <div className='loading-response'> <p>Thinking...</p></div>}
            </div>
            {chatData.response && (
                <div className='chat-actions'>
                    <img
                        src={chatData.isLiked ? "/images/icon/thumb-up-filled.svg" : "/images/icon/thumb-up.svg"}
                        alt="like"
                        className={`action-item ${chatData.isLiked ? 'active' : ''}`}
                        onClick={handleLike}
                    />
                    <img
                        src={chatData.isDisliked ? "/images/icon/thumb-down-filled.svg" : "/images/icon/thumb-down.svg"}
                        alt="dislike"
                        className={`action-item ${chatData.isDisliked ? 'active' : ''}`}
                        onClick={handleDislike}
                    />
                    <img
                        src="/images/icon/copy.svg"
                        alt="copy"
                        className={`action-item ${isMessageCopied ? 'active' : ''}`}
                        onClick={handleCopy}
                    />
                </div>
            )}
        </div>
    );
};

export default ChatItem